// extracted by mini-css-extract-plugin
module.exports = {"MuteUnmuteButton":"styles_MuteUnmuteButton__PDKsh"};